export default __webpack_public_path__ + "static/slider1-2ef66255150d78a31013615306c10228.png";